import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import enTranslations from './locales/en.json'
import arTranslations from './locales/ar.json'

const savedLang = typeof window !== 'undefined' ? localStorage.getItem('estipana_lang') : null;
const initialLang = savedLang === 'primary' ? 'en' : (savedLang || 'ar');

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: initialLang,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: enTranslations
      },
      ar: {
        translation: arTranslations
      },
      // Secondary language will be added dynamically from DB via addResourceBundle
      secondary: {
        translation: {}
      }
    }
  })

export default i18n
